<style rel="stylesheet/scss" lang="scss">
  @import url('//cdnjs.cloudflare.com/ajax/libs/leaflet/1.4.0/leaflet.css');

  .leaflet-map {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    z-index: var(--map-z-index);

    * {
      box-sizing: border-box;
      font-family: 'Roboto', sans-serif;
      font-size: 14px;
      font-weight: 400;
    }

    *:focus {
      outline: 0;
    }

    .leaflet-pane {
      z-index: var(--map-z-index);
    }

    .fa {
      font-family: "FontAwesome" !important;
    }

    .vue2leaflet-map {
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
    }

    &__directions {
      position: absolute !important;
      top: 15px;
      right: 15px;
      height: 36px;
      z-index: calc(var(--map-z-index) + 2);
      background-color: white;
      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
      border-radius: 4px;
      cursor: pointer;

      &__button {
        display: inline-block;
        position: relative;
        height: 36px;
        margin: 0;
        padding: 0 12px;
        line-height: 36px;
        color: var(--map-accent-color);
        transition: color 150ms ease-out;

        &__icon {
          display: inline;
          fill: var(--map-accent-color);
          height: 1em;
          width: 1em;
          line-height: 36px;
          vertical-align: middle;
          margin: 0 6px 0 0;
          transition : fill 150ms ease-out;

          svg {
            display: inline-block;
            height: 1em;
            width: 1em;
            margin-top: 4px !important;
          }
        }

        &:hover {
          color: #333333;
        }

        &:hover &__icon {
          fill: #333333;
        }
      }
    }

    &__zoom {
      position: absolute !important;
      bottom: 15px;
      left: 15px;
      height: 36px;
      z-index: calc(var(--map-z-index) + 2);
      background-color: white;
      box-shadow: 0 0 5px 0 rgba(0,0,0,0.5);
      border-radius: 4px;
      cursor: pointer;

      &__in,
      &__out {
        display: inline-block;
        position: relative;
        width: 36px;
        height: 36px;
        margin: 0;
      }

      &__in:before {
        content: '';
        width: 15px;
        height: 3px;
        border-top: 3px solid var(--map-accent-color);
        display: block;
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition : border 150ms ease-out;
      }

      &__in:after {
        content: '';
        width: 3px;
        height: 15px;
        border-right: 3px solid var(--map-accent-color);
        display: block;
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition : border 150ms ease-out;
      }

      &__in:hover:before {
        border-top: 3px solid #333333;
      }

      &__in:hover:after {
        border-right: 3px solid #333333;
      }

      &__out:before {
        content: '';
        width: 15px;
        height: 3px;
        border-top: 3px solid var(--map-accent-color);
        display: block;
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition : border 150ms ease-out;
      }

      &__out:hover:before {
        border-top: 3px solid #333333;
      }
    }

    &__view {
      position: absolute !important;
      bottom: 15px;
      left: 94px;
      height: 36px;
      z-index: calc(var(--map-z-index) + 2);
      background-color: white;
      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
      border-radius: 4px;
      cursor: pointer;

      &--zoomless {
        left: 15px;
      }

      &__toggle {
        display: inline-block;
        position: relative;
        width: 36px;
        height: 36px;
        margin: 0;

        &__icon {
          display: block;
          box-sizing: border-box;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 24px;
          height: 24px;
          fill: var(--map-accent-color);
          transition : fill 150ms ease-out;
        }

        &:hover &__icon {
          fill: #333333;
        }
      }
    }

    &__fullscreen {
      position: absolute !important;
      top: 15px;
      right: 15px;
      height: 36px;
      z-index: calc(var(--map-z-index) + 2);
      background-color: white;
      box-shadow: 0 0 5px 0 rgba(0,0,0,0.5);
      border-radius: 4px;
      cursor: pointer;

      &__toggle {
        display: inline-block;
        position: relative;
        width: 36px;
        height: 36px;
        margin: 0;

        &__icon {
          display: block;
          box-sizing: border-box;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border: 3px solid var(--map-accent-color);
          width: 15px;
          height: 15px;
          transition : border 150ms ease-out;

          &:before,
          &:after {
            content: '';
            width: 4px;
            height: 18px;
            background: white;
            display: block;
            box-sizing: border-box;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition : border 150ms ease-out;
          }

          &:after {
            width: 18px;
            height: 4px;
          }
        }

        &:hover &__icon {
          border: 3px solid #333333;
        }
      }
    }

    &__container {
      display: block;
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }

    .leaflet-control-attribution {
      a {
        &:link,
        &:hover,
        &:visited,
        &:active {
          color: black;
        }
        &:hover {
          color: var(--map-accent-color);
        }
      }
    }

    .leaflet-cluster-anim .leaflet-marker-icon, .leaflet-cluster-anim .leaflet-marker-shadow {
      transition: transform 0.3s ease-out, opacity 0.3s ease-in;
    }

    .leaflet-cluster-spider-leg {
      opacity: 0;
      transition: stroke-dashoffset 0.3s ease-out, stroke-opacity 0.3s ease-in;
    }

    .marker-cluster {
      color: var(--map-accent-dif-color);
      font-weight: 600;
      text-align: center;
      font: 12px "Helvetica Neue", Arial, Helvetica, sans-serif;
      transition: transform 0.3s ease;

      div {
        font-size: 16px;
        position: relative;
        width: 56px;
        height: 62px;
        background: var(--cluster-url) no-repeat 0 0;

        &:hover {
          transition: transform 0.2s cubic-bezier(0.25, 0, 0.75, 2);
          transform: scale(1.2, 1.2);
        }
      }

      span {
        line-height: 56px;
      }
    }
  }

</style>

<template>
  <div
    ref="container"
    class="leaflet-map"
    :style="baseStyles">

    <link
      v-if="externalStylesheet !== ''"
      rel="stylesheet"
      :href="externalStylesheet"
      type="text/css" />

    <div
      v-if="zoomControls && controls"
      class="leaflet-map__zoom">

      <div
        @click="handleZoomIn"
        class="leaflet-map__zoom__in">
        <i class="leaflet-map__zoom__in__icon"></i>
      </div>

      <div
        @click="handleZoomOut"
        class="leaflet-map__zoom__out">
        <i class="leaflet-map__zoom__out__icon"></i>
      </div>

    </div>

    <div
      v-if="viewControls && controls"
      :class="viewButtonClass">

      <div
        @click="handleToggleView"
        class="leaflet-map__view__toggle">
        <i
          v-if="mapStyle === 'street'"
          class="leaflet-map__view__toggle__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z"/></svg>
        </i>
        <i
          v-else
          class="leaflet-map__view__toggle__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z"/><circle cx="18" cy="6" r="5"/><path d="M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z"/></svg>
        </i>
      </div>

    </div>

    <div
      v-if="!hasAutocomplete && !hasStartingWaypoint && directionControls && controls"
      @click="hasAutocomplete = true"
      class="leaflet-map__directions">

      <div
        class="leaflet-map__directions__button">
        <i
          class="leaflet-map__directions__button__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"/></svg>
        </i>
        Get Driving Map
      </div>

    </div>

    <div class="leaflet-map__container">

      <Autocomplete
        @showWaypoints="handleShowWaypoints"
        @closeAutocomplete="handleCloseAutocomplete"
        v-if="!hasStartingWaypoint && hasAutocomplete"></Autocomplete>

      <OSRM
        v-if="hasStartingWaypoint"
        ref="osrm"
        :zIndex="zIndex"
        :clusterColor="clusterColor"
        :waypoints="mapMarkers"
        @closeOSRM="handleCloseOSRM"
        @showPolyline="handleShowPolyline"></OSRM>

      <LMap
        class="leaflet-map__map"
        ref="map"
        :center.sync="center"
        :zoom.sync="zoom"
        :max-zoom="mapOptions.maxZoom"
        :min-zoom="mapOptions.minZoom"
        :max-bounds="mapOptions.maxBounds"
        :options="{
          scrollWheelZoom: scrollZoom,
          zoomControl: mapOptions.zoomControl,
          attributionControl: mapOptions.attributionControl,
          editable: mapOptions.editable
        }">

        <LGeoJson
          ref="polygon"
          v-for="(polygon, index) in polygons"
          :key="index"
          :geojson="polygon"
          :options="polygonOptions">
        </LGeoJson>

        <LTileLayer
          ref="tile"
          class="leaflet-map__tiles"
          :url="tileStyle"
          :options="{
            tileSize: 512,
            zoomOffset: -1,
          }"
          :detect-retina="true"
          attribution="<a href='//www.maptiler.com/license/maps/' target='_blank'>&copy; MapTiler</a> | <a href='//www.openstreetmap.org/about/' target='_blank'>&copy; OpenStreetMap</a>">
        </LTileLayer>

        <LMarkerCluster
          ref="cluster"
          :key="`cluster=${hasStartingWaypoint}`"
          :options="clusterOptions">

          <LMarker
            ref="marker"
            class="leaflet-map__marker"
            v-for="(marker, index) in mapMarkers"
            :key="index"
            :lat-lng="marker.location"
            :icon="getMarkerImage(marker.color)"
            :riseOnHover="true"
            :riseOffset="250"
            :draggable="false"
            @click="$parent.$emit('emitMarkerClick', marker)">

            <LPopup
              ref="popup"
              v-if="marker.popup"
              class="leaflet-map__popup"
              :content="marker.popup"
              :options="{
                maxWidth: popupOptions.maxWidth,
              }">
            </LPopup>

            <LTooltip
              ref="tooltip"
              v-if="marker.tooltip"
              class="leaflet-map__tooltip"
              :content="marker.tooltip">
            </LTooltip>

          </LMarker>

        </LMarkerCluster>

      </LMap>

    </div>

  </div>
</template>

<script lang="js">
  import Vue from 'vue';
  import 'leaflet';
  import {LMap, LMarker, LPopup, LTileLayer, LTooltip, LGeoJson} from 'vue2-leaflet';
  import Autocomplete from './components/Autocomplete.vue';
  import OSRM from './components/OSRM.vue';
  import LMarkerCluster from 'vue2-leaflet-markercluster';
  import colorSelector from './utils/colorSelector.js';
  import debounce from 'lodash/debounce';
  import has from 'lodash/has';
  import get from 'lodash/get';
  import {MAP_URLS} from './lib/constents/config';
  import notEmpty from './utils/notEmpty';

  export default Vue.extend({
    name: 'map',
    props: {
      zIndex: {
        type: Number,
        default: () => 9995,
      },
      scrollZoom: {
        type: Boolean,
        default: () => true,
      },
      zoom: {
        type: Number,
        default: () => 5,
      },
      center: {
        type: Object,
        default: () => ({
          lat: 39.613645,
          lng: -100.2352187,
        }),
      },
      mapStyle: {
        type: String,
        default: () => 'street',
      },
      markers: {
        type: Array,
        default: () => [],
      },
      polygons: {
        type: Array,
        default: () => [],
      },
      markerColor: {
        type: String,
        default: () => '556677',
      },
      clusterColor: {
        type: String,
        default: () => '8A99A8',
      },
      maxClusterRadius: {
        type: Number,
        default: () => 50,
      },
      polygonColor: {
        type: String,
        default: () => '556677',
      },
      zoomControls: {
        type: Boolean,
        default: () => true,
      },
      viewControls: {
        type: Boolean,
        default: () => true,
      },
      directionControls: {
        type: Boolean,
        default: () => false,
      },
      controls: {
        type: Boolean,
        default: () => true,
      },
      externalStylesheet: {
        type: String,
        default: () => '',
      },
    },
    data() {
      return {
        isLoaded: false,
        isRedrawing: false,
        hoveredItem: null,
        polylines: null,
        startingWaypoint: null,
        hasAutocomplete: false,
        highestDistance: 25,
        clusterImage: `url("https://dynamic-images.rewn.io/cluster/${this.clusterColor}.svg")`,
      };
    },
    computed: {
      hasStartingWaypoint() {
        return this.startingWaypoint !== null;
      },
      mapMarkers() {
        return this.startingWaypoint
          ? [this.startingWaypoint, ...this.markers]
          : this.markers;
      },
      popupOptions() {
        return {
          maxWidth: 500,
        };
      },
      mapOptions() {
        return {
          maxZoom: 18,
          minZoom: 5,
          trackResize: true,
          zoomControl: false,
          attributionControl: true,
          editable: false,
          maxBounds: L.latLngBounds(
            L.latLng(5.499550, -167.276413), // Southwest
            L.latLng(83.162102, -52.233040),  // Northeast
          ),
        };
      },
      polygonOptions() {
        return {
          fill: true,
          fillColor: this.polygonColor,
          fillOpacity: 0.1,
          color: this.polygonColor,
          opacity: 0.5,
          weight: 1,
        };
      },
      clusterOptions() {
        return {
          animate: true,
          showCoverageOnHover: false,
          zoomToBoundsOnClick: true,
          removeOutsideVisibleBounds: true,
          spiderfyOnMaxZoom: true,
          maxClusterRadius: this.maxClusterRadius,
          spiderLegPolylineOptions: {
            opacity: 0,
          },
          disableClusteringAtZoom: this.hasStartingWaypoint ? 4 : 17,
        };
      },
      viewButtonClass() {
        return (this.zoomControls === true)
          ? 'leaflet-map__view'
          : 'leaflet-map__view leaflet-map__view--zoomless';
      },
      cords() {
        if (!this.mapMarkers.length) {
          return [];
        }
        return this.mapMarkers
          .map(geo => has(geo, 'location.lat') && has(geo, 'location.lon') && has(geo, 'id')
            ? L.latLng(get(geo, 'location.lat'), get(geo, 'location.lon'))
            : [])
          .filter(cord => cord !== undefined);
      },
      tileStyle() {
        return this.mapStyle === 'street' ? MAP_URLS.STREET : MAP_URLS.SATELLITE;
      },
      baseStyles() {
        return {
          '--map-accent-color': `#${this.clusterColor}`,
          '--map-accent-dif-color': colorSelector(this.clusterColor),
          '--cluster-url': this.clusterImage,
          '--map-z-index': this.zIndex,
        };
      },
    },
    methods: {
      notEmpty,
      handleCloseOSRM() {
        this.mapObject.removeLayer(this.polylines);
        this.polylines = null;
        this.startingWaypoint = null;
      },
      handleCloseAutocomplete() {
        this.hasAutocomplete = false;
      },
      handleShowWaypoints(value) {
        this.$nextTick(() => {
          this.startingWaypoint = typeof value === 'object' ? value : null;
        });
      },
      handleShowPolyline(value) {
        if (value.length) {
          this.polylines = L.polyline(value, {
            smoothFactor: 1,
            weight: 6,
            opacity: 0.8,
            color: `#11A900`,
            interactive: false,
          });
          this.polylines.addTo(this.mapObject);
        }
      },
      getMarkerImage(color) {
        return L.icon({
          iconUrl: `//dynamic-images.rewn.io/pin/${color ? color : this.markerColor}.svg`,
          iconSize: [28, 42],
          iconAnchor: [14, 42],
        });
      },
      handleRedrawMap: debounce(function() {
        this.isRedrawing = true;
        this.mapObject.invalidateSize();
        this.isRedrawing = false;
      }, 500),
      handleToggleView() {
        this.mapStyle = this.mapStyle === 'street' ? 'satellite' : 'street';
      },
      handleZoomIn() {
        this.mapObject.setZoom(this.mapObject.getZoom() + 1);
      },
      handleZoomOut() {
        this.mapObject.setZoom(this.mapObject.getZoom() - 1);
      },
    },
    watch: {
      cords: {
        handler: function(value) {
          if (!value.length) {
            return;
          }
          const vm = this;
          vm.mapObject.invalidateSize();
          setTimeout(() => {
            vm.mapObject.fitBounds(L.latLngBounds(value));
            vm.mapObject.setZoom(this.zoom);
          }, 500);
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      this.mapObject = this.$refs.map.mapObject;
      this.mapObject.on('resize', this.handleRedrawMap);
      this.handleRedrawMap();
      this.isLoaded = true;
    },
    components: {
      LMap,
      LMarker,
      LPopup,
      LTileLayer,
      LTooltip,
      LGeoJson,
      LMarkerCluster,
      OSRM,
      Autocomplete,
    },
  });
</script>
